import React from 'react';
import LoginContainer from './LoginContainer';
import clsx from 'clsx';

const LoginPage = () => {
  return (
    <div
      className={clsx(
        'container',
        'grid',
        'pt-6',
        'pb-6',
        'place-items-center',
        'md:pt-8',
        'md:pb-8',
        'lg:pt-10',
        'lg:pb-10'
      )}
    >
      <div className={clsx('w-full', 'sm:max-w-md')}>
        <LoginContainer />
      </div>
    </div>
  );
};
export default LoginPage;
